import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { motion } from 'framer-motion';
export var TruncatedNodeText = styled(motion.span)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n"], ["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow-x: hidden;\n"])));
export var UniversalNodeContainer = styled(motion.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-left: ", ";\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-left: ", ";\n  ", "\n"])), function (_a) {
    var $indent = _a.$indent;
    return "calc(".concat($indent || 0, " * 1rem)");
}, function (_a) {
    var $truncateLongText = _a.$truncateLongText;
    return $truncateLongText
        ? "\n    overflow-x: hidden;\n    min-width: 0;\n\n  "
        : "";
});
export var UniversalNode = styled(UniversalNodeContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-direction: row;\n  align-items: center;\n  height: ", ";\n  ", ";\n  border-top: ", ";\n  border-top-color: ", ";\n  ", ";\n\n  ", "\n"], ["\n  flex-direction: row;\n  align-items: center;\n  height: ", ";\n  ", ";\n  border-top: ", ";\n  border-top-color: ", ";\n  ", ";\n\n  ", "\n"])), function (_a) {
    var $height = _a.$height;
    return $height || 'initial';
}, function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return "background-color: ".concat($backgroundColor || 'initial', ";");
}, function (_a) {
    var $border = _a.$border;
    return $border || '1px solid';
}, function (_a) {
    var $borderColor = _a.$borderColor;
    return $borderColor || 'transparent';
}, function (_a) {
    var $selected = _a.$selected, $selectedBgColor = _a.$selectedBgColor;
    return $selected && $selectedBgColor
        ? "background-color: ".concat($selectedBgColor || 'initial')
        : '';
}, function (_a) {
    var $hoverColor = _a.$hoverColor;
    return $hoverColor
        ? "\n      &:hover {\n        cursor: pointer;\n        background-color: ".concat($hoverColor || 'initial', ";\n      }\n    ")
        : "";
});
export var RowBlock = styled(motion.div)(function (_a) {
    var $truncateLongText = _a.$truncateLongText;
    return [
        "display: flex;",
        "flex-direction: row;",
        $truncateLongText ? "overflow-x: hidden; min-width: 0;" : ""
    ];
});
export var ColumnBlock = styled(RowBlock)(function () { return ["flex-direction: column;"]; });
export var TextBlock = styled(motion.p)(function (_a) {
    var $color = _a.$color, $hoverColor = _a.$hoverColor, $selected = _a.$selected, $selectedColor = _a.$selectedColor, $truncateLongText = _a.$truncateLongText;
    return [
        "padding: 0;",
        "margin: 0;",
        "color: ".concat($color || 'initial', ";"),
        $selected && $selectedColor ? "color: ".concat($selectedColor || 'initial', ";") : "",
        $hoverColor
            ? "&:hover {\n    color: ".concat($hoverColor, ";\n  }")
            : "",
        $truncateLongText
            ? "\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  "
            : ""
    ];
});
export var TextFragment = styled(TextBlock).attrs({ as: 'span' })(function () { return []; });
export var IconBlock = styled(motion.span)(function (_a) {
    var $size = _a.$size, $color = _a.$color;
    return [
        "display: flex;",
        "flex-direction: column;",
        "align-items: center;",
        "justify-content: center;",
        "width: ".concat($size || '1rem', ";"),
        "height: ".concat($size || '1rem', ";"),
        "svg {\n    width: 100%;\n    height: 100%;\n    & * {\n      fill: ".concat($color, ";\n      stroke: ").concat($color, ";\n    }\n  }")
    ];
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Elements.js.map